import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { YInput } from '../../../ui/YInput';
import '../styles/auth-design.css';

export function AuthPasswordInput({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  invalid = false,
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="auth-password-wrap">
      <YInput
        id={id}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        invalid={invalid}
      />
      <button
        type="button"
        className="auth-password-toggle"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        {show ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
      </button>
    </div>
  );
}
